import { useParams, useNavigate } from "react-router-dom";
import { IoReturnUpBackOutline } from "react-icons/io5";
import ReactMarkdown from "react-markdown";
import "../style/Details.css";

function DetailsPage({ cards }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const card = cards.find((c) => c.id === parseInt(id));

  if (!card) {
    return (
      <div className="loading-container">
        <img src="/loading.png" alt="Loading..." className="loading" />
      </div>
    );
  }
  console.log(card)
  return (
    <div className="details-content">
      <div className="details-content-card">
        <IoReturnUpBackOutline
          className="back-icon"
          onClick={() => navigate("/")}
        />
        <div className="card">
            <div className="title-section">
              <h1>{card.Title}</h1>
            </div>
          <div className="img-container">
            {<img src={`https://strapi.jway-services.ma/${card.images[0].url}`} alt={card.images[0].alternativeText  || ""} />}
          </div>
          <div className="text-container">
            <div className="body">
              <div className="description">
                  {
                    card.Parts.map((part,index) => {
                      return(
                        <div key={index} className="part">
                          <h2>{part.SubTitle}</h2>
                          <ReactMarkdown>
                            {part.Description}
                          </ReactMarkdown>
                          {part.Functionalities && part.Functionalities.length > 0 &&
                          <>
                            <h2 className="functionalities">Fonctionnalités</h2>
                            <div className="tags">
                            {
                              part.Functionalities.map(f => (<span className="functionality-tag">{f.title}</span>))
                            }
                            </div>
                          </> 
                          }
                        </div>
                    )})
                  }
              </div>
              <div className="div-explore">
                  <a href="https://jway.ma/" class="explore-btn-mention">Notre Site Web</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailsPage;
